export const COLUMNS_COUNT_S = 2;
export const COLUMNS_COUNT_M = 3;
export const PREFERRED_RIBBON_POSITION = 6;

export const RIBBON_POSITION_S = 6;
export const RIBBON_POSITION_L = 8;

export const LIST_VIEW_TEASER_POSITION = 15;

export const RELATED_SEARCH_ROW = 6;
export const RELATED_SEARCH_POSITION_S = RELATED_SEARCH_ROW * COLUMNS_COUNT_S; // 12
export const RELATED_SEARCH_POSITION_M = RELATED_SEARCH_ROW * COLUMNS_COUNT_M; // 18
export const RELATED_SEARCH_POSITION_L = RELATED_SEARCH_ROW * 4; // 24
